import { render } from "./BrowsePortfolioLists.vue?vue&type=template&id=b65f3b16&scoped=true"
import script from "./BrowsePortfolioLists.vue?vue&type=script&lang=js"
export * from "./BrowsePortfolioLists.vue?vue&type=script&lang=js"

import "./BrowsePortfolioLists.vue?vue&type=style&index=0&id=b65f3b16&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b65f3b16"]])

export default __exports__